export const emptyModelInputs = () => ({ schema_version: "1.0", field_parameters: {}, farm_settings: {}, daily_climate: [] });
export const moisturePercent = "Moisture Content Of Crop Percentage";
export const moistureFraction = "Moisture Content Of Crop";

// Keep the two native representations consistent, including after a server round trip.
export function changeModelParameter(profile, group, key, value) {
  const next = { ...emptyModelInputs(), ...profile, [group]: { ...profile?.[group] } };
  if (value === undefined) delete next[group][key];
  else next[group][key] = value;
  if (group === "farm_settings" && key in (profile?.soil_source?.settings || {})) {
    // Edited values remain valid manual inputs; they must not retain official attribution.
    delete next.soil_source;
  }
  if (group === "field_parameters" && [moisturePercent, moistureFraction].includes(key)) {
    delete next[group][key === moisturePercent ? moistureFraction : moisturePercent];
  }
  return next;
}

export function modelInputsOrNull(profile) {
  if (!profile) return profile;
  return Object.keys(profile.field_parameters || {}).length || Object.keys(profile.farm_settings || {}).length || profile.daily_climate?.length || profile.history_start_year != null ? profile : null;
}

export const climateHeaders = ["date", "mean_temperature_c", "precipitation_mm", "evapotranspiration_mm"];
export function parseClimateCsv(text, cropYear) {
  const lines = text.replace(/^\uFEFF/, "").trim().split(/\r?\n/);
  if (lines.shift()?.trim() !== climateHeaders.join(",")) throw new Error(`Use these CSV columns: ${climateHeaders.join(",")}`);
  if (!lines.length || lines.length > 36600) throw new Error("Provide 1 to 100 complete calendar years of daily climate.");
  let previous;
  const days = lines.map((line, index) => {
    const cells = line.split(",").map(cell => cell.trim());
    const date = new Date(`${cells[0]}T00:00:00Z`);
    if (cells.length !== 4 || !/^\d{4}-\d{2}-\d{2}$/.test(cells[0]) || !Number.isFinite(date.valueOf()) || date.toISOString().slice(0, 10) !== cells[0]) throw new Error(`Invalid date or columns on CSV row ${index + 2}.`);
    if (previous !== undefined && date.valueOf() - previous !== 86400000) throw new Error(`Dates must be consecutive and unique (row ${index + 2}).`);
    previous = date.valueOf();
    const numbers = cells.slice(1).map(Number);
    if (cells.slice(1).some(cell => cell === "") || numbers.some(n => !Number.isFinite(n)) || numbers[1] < 0 || numbers[2] < 0) throw new Error(`Invalid climate measurement on CSV row ${index + 2}. Rainfall and evapotranspiration cannot be negative.`);
    return Object.fromEntries(climateHeaders.map((key, i) => [key, i ? numbers[i - 1] : cells[0]]));
  });
  if (!days[0].date.endsWith("-01-01") || !days.at(-1).date.endsWith("-12-31")) throw new Error("Daily climate must cover complete calendar years, including leap days.");
  if (cropYear && !days.some(day => day.date === `${cropYear}-01-01`)) throw new Error(`Include the crop year ${cropYear}.`);
  return days;
}

export function climateCsv(days) {
  return [climateHeaders.join(","), ...days.map(day => climateHeaders.map(key => day[key]).join(","))].join("\n") + "\n";
}
